var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"head"},[_c('main-head',{attrs:{"title":_vm.headTitle,"content":_vm.headData,"src":_vm.HeadImg}})],1),_c('Main',{attrs:{"list-arr":_vm.listArr,"get-all-object-list":_vm.getAllObjectList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }